import { cn } from "@/lib/utils";
import * as React from "react";

/**
 * Loading placeholder. A slow cream shimmer rather than a pulsing grey block —
 * it should feel like paper, not like a spinner in disguise.
 */
const Skeleton = ({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) => (
  <div
    aria-hidden
    className={cn(
      "rounded-none bg-kf-cream",
      "animate-pulse [animation-duration:2.4s]",
      className
    )}
    {...props}
  />
);

/** Text-line skeletons with varied widths so they read as prose, not bars. */
const SkeletonText = ({
  lines = 3,
  className,
}: {
  lines?: number;
  className?: string;
}) => (
  <div className={cn("flex flex-col gap-3", className)}>
    {Array.from({ length: lines }).map((_, i) => (
      <Skeleton
        key={i}
        className="h-3"
        style={{ width: `${[100, 92, 78, 96, 64][i % 5]}%` }}
      />
    ))}
  </div>
);

export { Skeleton, SkeletonText };
